import React from 'react'

const Notifications = ({children}) => {
  return (
    <div className='fixed max-w-md w-full right-2.5 top-20 z-40 pl-2.5'>
        {children}
    </div>
  )
}

export default Notifications